import { TimeFrames } from '@modules/Discover/Components/NFTsTab'
import { TokenPriceWithChange } from '@plug-core/clients/CacheClient'
import { ICP_ICP_ID } from '@plug-core/constants/tokenIds'

export const getTop5collections = async (
  selectedTimeFrame: TimeFrames,
  tokenPrices: TokenPriceWithChange
) => {
  const params: Record<string, string> = {}

  if (selectedTimeFrame === TimeFrames.PastDay) {
    const currentTimeInMillis = new Date().getTime()
    const dayBeforeTimeInMillis = currentTimeInMillis - 24 * 60 * 60 * 1000
    params.fromTimeMillis = dayBeforeTimeInMillis.toString()
    params.toTimeMillis = currentTimeInMillis.toString()
  }

  const formatedParams = new URLSearchParams(params)
  const response = await fetch(
    `https://api.nftgeek.app/api/1/collectionSummaries?${formatedParams}`
  )

  if (!response.ok) {
    throw new Error('Network response was not ok')
  }

  const data = await response.json()
  const icpPrice = tokenPrices[ICP_ICP_ID].price || 1

  const top5CollectionsByVolume = data.collectionSummaries
    .sort(
      (a: { transactionsVolumeUsd: number }, b: { transactionsVolumeUsd: number }) =>
        b.transactionsVolumeUsd - a.transactionsVolumeUsd
    )
    .slice(0, 5)
    .map(
      (collectionData: {
        collection: { name: string; canisterId: string }
        transactionsVolumeUsd: number
      }) => ({
        name: collectionData.collection.name,
        canisterId: collectionData.collection.canisterId,
        icpVolume: collectionData.transactionsVolumeUsd / 10000 / icpPrice,
      })
    )

  return top5CollectionsByVolume
}
